import { defineMessages } from 'react-intl-next';

export const i18n: {
	buttonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	buttonLabel: {
		id: 'search-page.navigation.search.work-items',
		defaultMessage: 'Search work items',
		description: 'Button to navigate to New Issue Navigator (NIN) to search for work items',
	},
});
